module.exports = __webpack_public_path__ + "static/media/Front.28759325.svg";